export const POST_FEED_REACTIONS_REACTION = 'post-feed-reactions.reaction';
